import CommonImages from "assets/images";
import { LazyComponent } from "components/common";
import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
const Home = React.lazy(() => import("pages/Home"));
const Plans = React.lazy(() => import("pages/Plans"));
const ThankYou = React.lazy(() => import("pages/Misc/ThankYou"));
const RefundPolicy = React.lazy(() => import("pages/Misc/RefundPolicy"));
const PrivacyPolicy = React.lazy(() => import("pages/Misc/PrivacyPolicy"));
const TermsAndConditions = React.lazy(() => import("pages/Misc/TermsAndConditions"));

function App() {
  useEffect(() => {
    function startGA(w: any, d: any, s: any, l: any, i: any) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    }
    setTimeout(() => startGA(window, document, "script", "dataLayer", "GTM-MPNZ8L3"), 4000);
  }, []);
  return (
    <BrowserRouter>
      <div
        style={{
          width: "100%",
          display: "flex",
          background: "#FFFFFF"
        }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/plans" element={<LazyComponent element={<Plans />} />} />
          <Route path="/thank-you" element={<LazyComponent element={<ThankYou />} />} />
          <Route path="/terms" element={<LazyComponent element={<TermsAndConditions />} />} />
          <Route path="/refund-policy" element={<LazyComponent element={<RefundPolicy />} />} />
          <Route path="/privacy-policy" element={<LazyComponent element={<PrivacyPolicy />} />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
